<template>
  <section>
    <div class="card rounded mb-5 podft-filter">
      <div class="card-header p-3 min-h-45px h-45px collapsible cursor-pointer rotate collapsed" data-bs-toggle="collapse" data-bs-target="#filter">
        <h5 class="card-title text-gray-700 fs-5 m-0 ms-3 text-gray-700 fw-bold">Фильтр</h5>
        <div class="card-toolbar rotate-180 m-0 me-3">
          <i class="ki-duotone ki-down fs-3"></i>
        </div>
      </div>
      <div id="filter" class="collapse">
        <div class="card-body p-5">
          <div class="row">
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8"> Статус </div>
              <div class="input-group input-group-sm mb-5">
                <select class="form-select" name="filter_name" v-model="filter.status">
                  <option value="null">Все</option>
                  <option value="1">Несогласованные</option>
                  <option value="2">C предупреждением</option>
                  <option value="3">Согласовано</option>
                </select>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8"> Тип клиента </div>
              <div class="input-group input-group-sm mb-5">
                <select class="form-select" name="filter_name" v-model="filter.person">
                  <option value="null">Все</option>
                  <option value="1">Физ.лицо</option>
                  <option value="0">Юр.лицо</option>
                </select>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">Cущность</div>
              <div class="input-group input-group-sm mb-5">
                <select class="form-select" name="filter_name" v-model="filter.entity">
                  <option value="null">Все</option>
                  <option value="0">Клиент</option>
                  <option value="1">Авто</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Наименование
              </div>
              <div class="input-group input-group-sm mb-5">
                <input v-model="filter.title" type="text" class="form-control" name="filter_name" id="filter_name" placeholder="Наименование"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Документ
              </div>
              <div class="input-group input-group-sm mb-5">
                <input type="text" v-model="filter.document" class="form-control" name="filter_document" id="filter_document" placeholder="Документ"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Дата обращения (начало - конец)
              </div>
              <div class="input-group input-group-sm mb-5">
                <input type="date" class="form-control" v-model="filter.appeal_start"/>
                <span class="input-group-text">-</span>
                <input type="date" class="form-control" v-model="filter.appeal_end"/>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Дата решения (начало - конец)
              </div>
              <div class="input-group input-group-sm mb-5">
                <input type="date" class="form-control" v-model="filter.solution_start"/>
                <span class="input-group-text">-</span>
                <input type="date" class="form-control" v-model="filter.solution_end"/>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between p-3">
          <button type="button" class="btn btn-light-warning btn-sm" @click="clearFilter">Сбросить</button>
          <button type="button" class="btn btn-primary btn-sm" @click="getFilter">Применить</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PodftFilter',
  props: {
    itemId: null,
    itemIndex: null
  },
  data() {
    return {
      showBack:       false,
      filter: {
        status:         '1',
        person:         'null',
        entity:         'null',
        title:          '',
        document:       '',
        appeal_start:   '',
        appeal_end:     '',
        solution_start: '',
        solution_end:   ''
      }
    }
  },
  methods: {
    getFilter() {
      if (this.filter.appeal_start.length === 0)   this.filter.appeal_start   = this.filter.appeal_end
      if (this.filter.appeal_end.length === 0)     this.filter.appeal_end     = this.filter.appeal_start
      if (this.filter.solution_start.length === 0) this.filter.solution_start = this.filter.solution_end
      if (this.filter.solution_end.length === 0)   this.filter.solution_end   = this.filter.solution_start
      this.$emit('filterLoader', true)
      this.$emit('filterHeaders', this.filter)
    },
    clearFilter() {
      const filter = {
        status:         '1',
        person:         'null',
        entity:         'null',
        title:          '',
        document:       '',
        appeal_start:   '',
        appeal_end:     '',
        solution_start: '',
        solution_end:   ''
      }
      this.filter = filter
      this.$emit('filterHeaders', filter)
    }
  }
}
</script>

<style></style>